import axios from './axiosInstance';
import { StudentImportResult , TeacherImportResult } from '../types/importTypes';
import { ApiResponse } from 'types/apiTypes';

/**
 * Payload for importing students via CSV upload.
 */
export interface StudentImportPayload {
  file: File;
}

export interface TeacherImportPayload {
  file: File;
}

/**
 * Import students using a CSV file (multipart/form-data).
 * Returns detailed result with created, skipped, and error metadata.
 */
export async function importStudents(
  payload: StudentImportPayload
): Promise<StudentImportResult> {
  const formData = new FormData();
  formData.append('file', payload.file);

  const response = await axios.post<ApiResponse<StudentImportResult>>(
    '/import/students',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return response.data.data;
}



export async function importTeachers(
  payload: TeacherImportPayload
): Promise<TeacherImportResult> {
  const formData = new FormData();
  formData.append('file', payload.file);

  const response = await axios.post<ApiResponse<TeacherImportResult>>(
    '/import/teachers',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );

  return response.data.data;
}